<template>
  <wp-items-view
    content-type="ask-dwg-articles"
    content-type-singular="ask-dwg-article"
    content-name="Ask DWG articles"
    content-name-singular="Ask DWG article"
  />
</template>

<script>
import WpItemsView from '@/views/wp-item/wp-items-view/WpItemsView.vue'

export default {
  components: {
    WpItemsView,
  },
}
</script>

<style scoped>

</style>
